/* eslint-disable */
export enum TipoPersona {   
    FISICA = 1,
    JURIDICA = 2    
}
